import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'
import * as Helpers from 'helpers'
import axios from 'axios'

declare const SEARCHSPRING_ID: string

export class ProductRecommended extends React.PureComponent<ProductRecommended.Props, ProductRecommended.State> {
  private slider: any
  public static sectionId = 'productRecommended';

  public static contextType = ShopifyNext.Context;

  private static kewl = new Helpers.ShopifyKewl({
    //@ts-ignore
    store: STOREFRONT_NAME,
    //@ts-ignore
    storeFrontKey: STOREFRONT_PASSWORD
  })

  constructor(props) {
    super(props)
    this.slider = React.createRef()
    this.state = {
      recommendations: [],
      wishlist: []
    }
  }
  
  componentDidMount(): void {
    this.fetchWishlistItems()
  }

  public async componentDidUpdate(prevProps) {
    const isSameProduct = prevProps?.product?.id === this?.props?.product?.id
    const hasRecommendations = this?.state?.recommendations?.length > 0
    if (!isSameProduct || !hasRecommendations) await this.getRecommendations()
    
  }

  private getRecommendations = async () => {
    const { section } = this.props
    const settings = section ? section?.settings : undefined
    let id = settings?.product ? settings?.product?.id : this.props.product?.id

    // get product recommendations from searchspring boost recommended api
    const apiUrl = `https://${SEARCHSPRING_ID}.a.searchspring.io/boost/${SEARCHSPRING_ID}/recommend`
    const resp = await axios.get(apiUrl, {
      params: {
        limits: 30,
        tags: 'cross-sell',
        product: id
      }
    }).catch(err => {
      console.error('error', err)
    })
    const results = resp && resp?.data?.[0]?.results
    if (results) {
      const urls = results.map(result => result?.mappings?.core?.url).filter(i => i)
      const handles = urls.map(url => url.replace('/products/', ''))
      const products = await ProductRecommended.kewl.productsByHandles(handles, ['id', 'title', 'handle', 'description', 'published_at', 'created_at', 'vendor', 'type', 'tags', 'price', 'price_min', 'price_max', 'available', 'price_varies', 'compare_at_price', 'compare_at_price_min', 'compare_at_price_max', 'compare_at_price_varies', 'variants', 'images', 'featured_image', 'options', 'url', 'media', 'requires_selling_plan', 'selling_plan_groups', 'siblingsQuantity', 'filteredSiblings'])
      this.setState({
        recommendations: products
      })
      return products
    } else {
      this.setState({
        recommendations: []
      })
      return []
    }
  }

  public next = () => {
    this.slider.current.slickNext()
  }

  public previous = () => {
    this.slider.current.slickPrev()
  }

  public fetchWishlistItems = () => {
    if (!window._swat || !window._swat.retailerSettings) {
      // console.error('Swat is not initialized')
      setTimeout(() => {
        // console.log('Swat is initialized')
        this.fetchWishlistItems()
      }, 1000)
    } else {
      window._swat?.fetch((res: any) => {
        // console.log('res:', res)
        this.setState({ wishlist: res })
        document.dispatchEvent(new CustomEvent('swym:wishlist-fetched'))
      })
    }
  };
  
  public checkWishlistItem = (product: any) => {
    const { wishlist } = this.state
    const productId = typeof product?.id === 'number' ? product?.id : parseInt(product?.id?.split?.('/')?.pop())
    const productVariantId = typeof product?.variants?.[0]?.id === 'number' ? product?.variants?.[0]?.id : parseInt(product?.variants?.[0]?.id?.split?.('/').pop?.())
    // console.log('wishlist', wishlist)
    // console.log('product', product)
    if (wishlist.length === 0) {
      console.warn('wishlist is empty')
      return false
    }

    // check if item.id matches any of the res.epi
    const isRes = wishlist.some((r: any) => {
      return r.epi === productId || 
        r.empi === productId || 
        r.epi === productVariantId
    })

    if (isRes) {
      // console.log('wishlist item found')
      return true
    }
    // console.log('wishlist item not found')
    return false
  };
  
  public toggleWishlist = (product: any, isInList: boolean): void => {
    const _this = this
    
    const productId = typeof product?.id === 'number' ? product?.id : parseInt(product?.id?.split?.('/')?.pop())
    const productVariantId = typeof product?.variants?.[0]?.id === 'number' ? product?.variants?.[0]?.id : parseInt(product?.variants?.[0]?.id?.split?.('/')?.pop())
    
    const productData = {
      ...window.SwymPageData,
      et: 4, // et 4 stands for wishlist event type
      epi: productVariantId, // unique variant ID of the product?.
      empi: productId, // Product ID or master product ID
      du: `${window.location.origin}/products/${product?.handle}`
    }
    
    if (isInList) {
      window._swat.removeFromWishList(
        productData,
        function (e: any) {
          console.log('wishlist item removed', e)
          document.dispatchEvent(new CustomEvent('swym:wishlist-updated'))
          _this.fetchWishlistItems()
        },
        function (e: any) {
          console.log('wishlist item failed', e)
        }
      )
    } else {
      window._swat.addToWishList(
        productData,
        function (e: any) {
          console.log('wishlist item added', e)
          document.dispatchEvent(new CustomEvent('swym:wishlist-updated'))
          _this.fetchWishlistItems()
        },
        function (e: any) {
          console.log('wishlist item failed', e)
        }
      )
    }
  }

  public render(): JSX.Element {
    const { section } = this.props
    const settings = section ? section?.settings : undefined
    let { recommendations } = this.state

    const sliderSettings = {
      centerPadding: '96px',
      arrows: false,
      infinite: true,
      swipeToSlide: true,
      slidesToScroll: 1,
      slidesToShow: 5,
      centerMode: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerPadding: '40px',
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            centerPadding: '40px',
          }
        },
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 3,
            centerPadding: '40px',
          }
        },
        {
          breakpoint: 1920,
          settings: {
            slidesToShow: 4,
            centerPadding: '40px',
          }
        }
      ]
    }

    let results
    if (recommendations.length) {
      //@ts-ignore
      results = Helpers.check(this, 'this.props.data.section.product?.settings.featuredcollection.products')
        && (recommendations.length < sliderSettings.slidesToShow)
        ? [...recommendations, ...this.props.data.section.product?.settings.featuredcollection.products]
        : [...recommendations]
    } else {
      results = []
    }
    return (
      <section className={'mt-3-2'} aria-label="Recommend Products">
        <div className={`pl-1-6 md:pl-3-6 mb-6-4 ${this.props.className ? this.props.className : ''}`}>
          <div className={`pl-0 mx-auto flex mb-3-2 pr-1-6 justify-between`}>
            <Snippets.Heading size={'h1'} tag={'h2'} className={'leading-none'}>
              {this.props.title ? this.props.title : settings?.title }
            </Snippets.Heading>
            <div className={'hidden md:flex flex-row'}>
              <button className={'outline-none opacity-30 hover:opacity-100 mr-2-2'} onClick={this.previous}>
                <span className={'block'}>
                  <Snippets.Icon name={'chevron_left'} width={18} />
                </span>
              </button>
              <button className={'outline-none opacity-30 hover:opacity-100'} onClick={this.next}>
                <span className={'block'}>
                  <Snippets.Icon name={'chevron_right'} width={18} />
                </span>
              </button>
            </div>
          </div>
          {recommendations && recommendations.length ? (
            <div>
              <Snippets.Slider refs={this.slider} settings={{ ...sliderSettings }} className={'theme-product-recommended'}>
                {results.map((product: any, i: number) => {
                  product = {
                    ...product,
                    compare_at_price: product?.compare_at_price_min,
                    price: product?.price_min
                  }
                  return <Snippets.CollectionProduct
                    collection={Helpers.check(this, 'this.props.data.collection') ? this.props.data.collection : null}
                    key={product?.title}
                    product={product}
                    list="Recommended products"
                    preventLazy
                    isInWishlist={this.checkWishlistItem(product)}
                    toggleWishlist={this.toggleWishlist}
                    wishlist={this.state.wishlist}
                  />
                })}
              </Snippets.Slider>
              <div className={'mt-3-2 md:hidden flex flex-row'}>
                <button className={'outline-none opacity-30 hover:opacity-100 mr-2-2'} onClick={this.previous}>
                  <span className={'block'}>
                    <Snippets.Icon name={'chevron_left'} width={18} label={'next slide'}/>
                  </span>
                </button>
                <button className={'outline-none opacity-30 hover:opacity-100'} onClick={this.next}>
                  <span className={'block'}>
                    <Snippets.Icon name={'chevron_right'} width={18} label={'previous slide'}/>
                  </span>
                </button>
              </div>
            </div>
          ) : (
            <div className={'sm:pl-2-4 lg:pl-2-8 xl:pl-12 2xl:pl-22 3xl:pl-32 4xl:pl-42 5xl:pl-25vw 6xl:pl-30vw flex items-center justify-between'}>
              <div className={'block w-full md:w-1/4 md:px-0-8'}>
                <div className={'ratio-5:6 content-placeholder mb-1'} />
                <p className={'content-placeholder w-3/4 py-1 mb-1'} />
                <p className={'content-placeholder w-1/4 py-0-5'} />
              </div>
              <div className={'block w-full md:w-1/4 md:px-0-8'}>
                <div className={'ratio-5:6 content-placeholder mb-1'} />
                <p className={'content-placeholder w-3/4 py-1 mb-1'} />
                <p className={'content-placeholder w-1/4 py-0-5'} />
              </div>
              <div className={'block w-full md:w-1/4 md:px-0-8'}>
                <div className={'ratio-5:6 content-placeholder mb-1'} />
                <p className={'content-placeholder w-3/4 py-1 mb-1'} />
                <p className={'content-placeholder w-1/4 py-0-5'} />
              </div>
              <div className={'block w-full md:w-1/4 md:px-0-8'}>
                <div className={'ratio-5:6 content-placeholder mb-1'} />
                <p className={'content-placeholder w-3/4 py-1 mb-1'} />
                <p className={'content-placeholder w-1/4 py-0-5'} />
              </div>
            </div>
          )
          }
        </div>
      </section >
    )
  }
}

export namespace ProductRecommended {
  export interface Props extends GlobalProps {
    title?: string;
    className?: string;
    product?: any;
    section?: any;
  }
  export interface State {
    recommendations: any;
    wishlist: any[];
  }
}
